import { useCallback } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { useTmapLogContext, pageIdInfos } from '@/providers'
import { useLocation } from 'react-router-dom'

const PATH_TO_PAGE_ID: Record<string, string> = {}

Object.values(pageIdInfos).forEach((info) => {
  if (!PATH_TO_PAGE_ID[info.url]) {
    PATH_TO_PAGE_ID[info.url] = info.pageId
  }
})

interface CommonErrorLogParams {
  displayMessage: string;
  apiName?: string;
  apiPath?: string;
  errorCode?: string;
  errorMessage?: string;
  statusCode?: number;
  error?: Record<string, unknown>;
}

function useCommonErrorLogs() {
  const { tmapLogClient } = useTmapLogContext()
  const location = useLocation()

  return useCallback((params: CommonErrorLogParams) => {
    const {
      displayMessage,
      apiName,
      apiPath,
      errorCode,
      errorMessage,
      statusCode,
      error,
    } = params

    const pathname = location.pathname
    const pageId = PATH_TO_PAGE_ID[pathname] ?? pathname

    try {
      const log = tmapLogClient('expose')
        .setServiceId('error')
        .setPageId('/error/error_exposed')
        .setCustom('display_message', displayMessage)
        .setCustom('display_type', 'full_screen')
        .setCustom('platform', 'web')
        .setCustom('service_name', 'drivinglife')
        .setCustom('screen_name', `/drivinglife/${pageId}`)

      if (apiName) log.setCustom('api_name', apiName)
      if (apiPath) log.setCustom('api_path', apiPath)
      if (errorCode) log.setCustom('error_code', errorCode)
      if (errorMessage) log.setCustom('error_message', errorMessage)
      if (statusCode) log.setCustom('status_code', statusCode)
      if (error) log.setCustom('error', error)

      log.send()

      datadogRum.addError(error, {
        error: { ...error, message: 'tscore:error:errorBoundary' },
      })
    } catch {
      // 에러 로깅 중 에러 발생 시 무한루프 방지를 위해 조용히 무시
    }
  }, [tmapLogClient, location.pathname])
}

export { useCommonErrorLogs }
export type { CommonErrorLogParams }
